<p>program-kit-info.sub works!</p>
